export const inclusionsQueryKeys = {
  all: ['inclusions'] as const,
  categories: () => [...inclusionsQueryKeys.all, 'categories'] as const,
  packageInclusions: () => [...inclusionsQueryKeys.all, 'package'] as const,
  packageInclusionsByOffer: (offerId: string) => [...inclusionsQueryKeys.packageInclusions(), offerId] as const,
  packageInclusionsByDeal: (offerId: string, dealSalesforceId: string, currencyisocode: string) =>
    [...inclusionsQueryKeys.packageInclusionsByOffer(offerId), dealSalesforceId, currencyisocode] as const,
  vendorInclusions: (vendorId: string, offerId: string) =>
    [...inclusionsQueryKeys.all, 'vendor', vendorId, offerId] as const,
  roomTypeInclusions: (offerId: string, roomTypeId: string) =>
    [...inclusionsQueryKeys.all, 'roomType', offerId, roomTypeId] as const,
};
